<template lang="pug">
  app-dialog(v-model="$_show" @confirm="registationCourt()" confirmText="Отправить" header="Регистрация суда")  
    app-text-field(v-model="form.alias" label="Алиас суда")
    app-text-field(v-model="form.login" label="Логин администратора суда")
    app-text-field(v-model="form.password" type="password" label="Пароль")
</template>

<script>
import { userService, courtService } from '@/_services'
import { AppDialogToggable } from '@/components'
import { $_user_utils } from '@/common/UserUtils'

export default {
  mixins: [AppDialogToggable, $_user_utils],
  name: 'login',
  data() {
    return {
      form: {
        alias:'',
        login:'',
        password:'',
      },
      error: null,
    }
  },
  created() {
    this.form.username = localStorage.getItem("LoginName")
    this.form.password = ''
  },

  mounted () {
    this.courtAlias()
    
  },

  computed: {
    hasSavedLogin () {
      return localStorage.getItem("LoginName") ? true : false
    }
  },
  methods: {
    courtAlias () {
      let form = this
      setTimeout(function() { form.form.alias = localStorage.getItem("courtAlias") }, 1000)
    },
    
    registationCourt () {
      courtService.courtRegister(this.form).then(data => {
        if (data == "error")  localStorage.setItem("error", "Ошибка авторизации")
        else if (data == "denied")  localStorage.setItem("error", "Пользователь не найден")
        else if (data == "exist")  localStorage.setItem("error", "Такой пользователь уже существует")
        else {
          userService.login(this.form.login, this.form.password).then(status => {
            if (status) {
              localStorage.setItem("LoginName", this.form.login)
              this.$user_utils_goToStartPage()
            }
          })
        }
      })
    }

  }
}
</script>

<style scoped>

</style>